// mutation-types.js
export const SET_FORM_ADMIN = 'SET_FORM_ADMIN'
export const SET_FORM_REPORT = 'SET_FORM_REPORT'